import type { BibleBookId } from "../../../lib/types/schema/bible/bibleManifestSchema";
import type { UseOpenApiQueryOptions } from "../../../request/hooks/openApi/useOpenApiQuery";
import { useOpenApiQuery } from "../../../request/hooks/openApi/useOpenApiQuery";

const urlBackendPath = "/bible/{translationId}/book/{bookId}/links" as const;

export type RequestBibleLinkedContentProps = Omit<
  UseOpenApiQueryOptions<typeof urlBackendPath>,
  "urlBackendPath"
> & {
  translationId: number;
  bookId: BibleBookId;
};

export const useRequestBibleLinkedContent = ({
  translationId,
  bookId,
  ...props
}: RequestBibleLinkedContentProps) =>
  useOpenApiQuery<typeof urlBackendPath>({
    urlBackendPath,
    params: {
      path: { translationId, bookId },
    },
    ...props,
  });
